import { MealKind } from "@/gql/graphql";
import { humanize } from "@/utils/string";

export function mealKindLabel(mealKind: MealKind): string {
  switch (mealKind) {
    case MealKind.AfternoonSnack:
      return "Afternoon snacks";
    case MealKind.PreWorkoutSnack:
      return "Pre-workout snacks";
    case MealKind.PostWorkoutSnack:
      return "Post-workout snacks";
    case MealKind.PreWorkoutMeal:
      return "Pre-workout meal";
    case MealKind.PostWorkoutMeal:
      return "Post-workout meal";
    default:
      return humanize(mealKind);
  }
}
